import { b as _defineProperty, _ as _getPrototypeOf, a as _possibleConstructorReturn, c as _inherits, d as _classCallCheck, e as _createClass, Q } from '../_chunks/dep-b05afc19.js';
import { IconBase } from '../icon.js';
import '../util/classname.js';
import '../util/size-props.js';
import '../util/check-url-and-load.js';

var _class;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var element = {
  "attributes": {
    "fill": "none",
    "viewBox": "0 0 24 24",
    "width": "1em",
    "height": "1em"
  },
  "nodeName": "svg",
  "children": [{
    "attributes": {
      "id": "thumb-down"
    },
    "nodeName": "g",
    "children": [{
      "attributes": {
        "id": "fill1",
        "fill": "transparent",
        "d": "M8 13L11.5 21.5L11.9932 21.4178C13.4398 21.1767 14.5 19.9251 14.5 18.4586V15H20.8195C21.4375 15 21.9075 14.4451 21.8059 13.8356L20.1393 3.8356C20.0589 3.35341 19.6417 3 19.1529 3H8V13Z"
      },
      "nodeName": "path",
      "children": []
    }, {
      "attributes": {
        "id": "stroke1",
        "stroke": "currentColor",
        "d": "M3 3V13M8 13V3H19.1529C19.6417 3 20.0589 3.35341 20.1393 3.8356L21.8059 13.8356C21.9075 14.4451 21.4375 15 20.8195 15H14.5V18.4586C14.5 19.9251 13.4398 21.1767 11.9932 21.4178L11.5 21.5L8 13Z",
        "stroke-linecap": "square",
        "stroke-width": 2
      },
      "nodeName": "path",
      "children": []
    }]
  }]
};
var ThumbDownIcon = (_class = /*#__PURE__*/function (_IconBase) {
  _inherits(ThumbDownIcon, _IconBase);
  var _super = _createSuper(ThumbDownIcon);
  function ThumbDownIcon() {
    var _this;
    _classCallCheck(this, ThumbDownIcon);
    _this = _super.call(this);
    _this.props = _objectSpread(_objectSpread({}, _this.props), {}, {
      id: "thumb-down"
    });
    return _this;
  }
  return _createClass(ThumbDownIcon);
}(IconBase), _defineProperty(_class, "icon", element), _class);
ThumbDownIcon = __decorateClass([Q("t-icon-thumb-down")], ThumbDownIcon);

export default ThumbDownIcon;
//# sourceMappingURL=thumb-down.js.map
